/**
 * Asynchronously loads the component for Companies
 */

import { lazyLoad } from 'utils/loadable';

export const CompaniesPage = lazyLoad(
  () => import('./index'),
  module => module.CompaniesPage,
);
